import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { PriceBreakDownViewModel } from 'models';

import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from 'uitk-react-menu';
import { UitkLink } from 'uitk-react-link';

export interface PriceBreakDownMenuProps {
  childContent?: React.ReactNode;
  id: string;
  priceBreakDownModel: PriceBreakDownViewModel[];
}

const LinkTracked = ClickTracker(UitkLink);

export const PriceBreakDownMenu = ({ childContent, id, priceBreakDownModel }: PriceBreakDownMenuProps) => {
  const [showMenu, setShowMenu] = React.useState<boolean>(false);
  const handleClick = () => setShowMenu(!showMenu);

  if (!priceBreakDownModel) {
    return null;
  }

  const { breakdownHeader } = priceBreakDownModel[0];

  if (!breakdownHeader) {
    return null;
  }

  const trackingRfrr = id === 'infosite-room-ratePlans' ? 'RoomsAndRates.PriceDetail' : 'RoomInfo.PriceDetail';

  return (
    <UitkMenu id="show" isOpen={showMenu} onTriggerClick={handleClick}>
      <UitkMenuTrigger>
        <LinkTracked linkName="price.breakdown.details" rfrr={trackingRfrr}>
          <button>{breakdownHeader}</button>
        </LinkTracked>
      </UitkMenuTrigger>
      <UitkMenuContainer width={250} position={PositionType.RIGHT}>
        {childContent}
      </UitkMenuContainer>
    </UitkMenu>
  );
};

PriceBreakDownMenu.displayName = 'PriceBreakDownMenu';
